import React from "react";
import { useTranslation } from "react-i18next";
import { BLUE_TWELVE, WHITE } from "../../../theme";
import { useStyles } from "../../../components/managementTable/styles";

export const DetailTabs = ({ bank }) => {
  const [tab, setTab] = React.useState(0);
  const classes = useStyles();
  const { t } = useTranslation();

  const BANK_DETAIL_TABS = [
    {
      id: 0,
      value: t("text_bank_details"),
    }
  ];
  return (
    <div>
      <div className={classes.thead}
        style={{
          display: "flex",
          padding: "10px 20px"
        }}
      >
        {BANK_DETAIL_TABS.map(({ id, value }) => {
          return (
            <div
              key={id}
              role="presentation"
              onClick={() => {
                setTab(id);
              }}
              style={{
                padding: "5px 10px",
                fontWeight: "500",
                cursor: "pointer",
                color: id === tab ? WHITE : BLUE_TWELVE,
                fontSize: 12,
              }}
            >
              {value}
            </div>
          );
        })}
      </div>
      <div style={{ padding: "10px 30px" }}>
        {tab === 0 && (
          <div>
            <DetailItem label={t("text_bank_name")} value={bank?.banksLean?.name ?? "N/A"} />
            <DetailItem label={t("text_bank_swift_code")} value={bank?.bankSwiftCode ?? "N/A"} />
            <DetailItem label={t("text_bank_address")} value={bank?.bankAddress ?? "N/A"} />
            <DetailItem label={t("text_account_number")}  value={bank?.accountNumber ?? "N/A"}/>
            <DetailItem label={t("text_account_title")} value={bank?.accountTitle ?? ""} />
            <DetailItem label={t("text_account_iban")} value={bank?.accountIban ?? "N/A"} />
          </div>
        )}
      </div>
    </div>
  );
};

const DetailItem = ({ label, value }) => {
  const { t } = useTranslation();
  return (
    <div style={{ padding: "7px 0px" }}>
      <div style={{ color: "gray", fontSize: 12 }}>{label}</div>
      <div
        style={{ fontSize: "0.85vw", fontWeight: 700, textTransform:"capitalize" }}
      >
        {value}
      </div>
    </div>
  );
};
